import { useTranslation } from "react-i18next";
import Dialog from "../../components/Modals/Dialog";

export interface ConfirmDialogProps {
  id: string;
  header?: string;
  body?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onCancel: (payload: { id: string }) => void;
  onConfirm: (payload: { id: string }) => void;
  onClose: (payload: { id: string }) => void;
}

function ConfirmDialog(props: ConfirmDialogProps) {
  const { t } = useTranslation();

  const header = props.header ? props.header : t("header_confirm");
  const body = props.body ? props.body : t("text_confirm");
  const cancelButtonText = props.cancelButtonText ? props.cancelButtonText : t("button_back");
  const confirmButtonText = props.confirmButtonText ? props.confirmButtonText : t("button_confirm");

  const handleClose = () => {
    props.onClose({ id: props.id });
  };

  const handleCancel = () => {
    props.onCancel({ id: props.id });
  };

  const handleConfirm = () => {
    props.onConfirm({ id: props.id });
  };

  const handleOverlayClick = () => {
    handleClose();
  };

  return (
    <div className="modal__default--open">
      <div className="modal__default__content">
        <Dialog
          header={header}
          cancelText={cancelButtonText}
          confirmText={confirmButtonText}
          onClose={handleClose}
          onCancel={handleCancel}
          onConfirm={handleConfirm}
        >
          {body}
        </Dialog>
      </div>
      <div className="modal__default__backdrop" onClick={handleOverlayClick} aria-hidden="true" />
    </div>
  );
}

export default ConfirmDialog;
